import { InputHTMLAttributes, Ref } from 'react';
import classnames from 'classnames';

const makeClassName = (disabled: boolean, invalid: boolean, role?: string) =>
  classnames({
    'text-input-text-color': true,
    block: true,
    'w-full': true,
    'h-10': true,
    'py-1.5': true,
    'px-2.5': true,
    'bg-clip-padding': true,
    rounded: true,
    border: true,
    'border-input-border-color': true,
    'focus:outline-none': true,
    'focus:border': true,
    'focus:border-input-focus-color': true,
    'focus:bg-input-background-color': true,
    'focus:text-input-focus-color': true,
    'placeholder:text-input-placeholder-text-color': true,
    'opacity-60': disabled,
    'outline-none': disabled,
    '!border-input-border-invalid-color': invalid,
    'focus:text-input-text-color': invalid,
    'focus:border-input-border-invalid-color': invalid,
    'bg-card-background-color': role === 'card',
    'focus:!bg-card-background-color': role === 'card',
    'bg-input-background-color': role === 'input',
    'focus:!bg-input-background-color': role === 'input',
  });

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  role?: string;
  ref?: Ref<HTMLInputElement>;
}

const Input = ({
  ref,
  invalid = false,
  role = 'input',
  disabled = false,
  ...props
}: Props) => (
  <input
    readOnly={disabled}
    autoComplete="off"
    ref={ref}
    className={makeClassName(disabled, invalid, role)}
    disabled={disabled}
    {...props}
  ></input>
);

Input.displayName = 'Input';

export default Input;
